import React, { useState, useCallback } from "react"

const REACTIONS = [
  { kind: "like", emoji: "\ud83d\udc4d", label: "Like" },
  { kind: "heart", emoji: "\u2764\ufe0f", label: "Love" },
  { kind: "fire", emoji: "\ud83d\udd25", label: "Fire" },
  { kind: "target", emoji: "\ud83c\udfaf", label: "Bullseye" },
  { kind: "money", emoji: "\ud83d\udcb0", label: "Money" },
]

const ReactionBar = ({ activityId, initialCounts = {}, userReactions = [], onReact, apiKey, token, userId }) => {
  const [counts, setCounts] = useState(() => {
    const c = {}
    REACTIONS.forEach(r => { c[r.kind] = initialCounts[r.kind] || 0 })
    return c
  })
  const [active, setActive] = useState(() => new Set(userReactions))
  const [pending, setPending] = useState(new Set())

  const toggleReaction = useCallback(async (kind) => {
    if (pending.has(kind)) return
    setPending(prev => new Set(prev).add(kind))

    const wasActive = active.has(kind)

    // Optimistic update
    setActive(prev => {
      const next = new Set(prev)
      wasActive ? next.delete(kind) : next.add(kind)
      return next
    })
    setCounts(prev => ({
      ...prev,
      [kind]: prev[kind] + (wasActive ? -1 : 1),
    }))

    try {
      if (onReact) {
        await onReact({ activityId, kind, action: wasActive ? "remove" : "add" })
      }
    } catch (err) {
      console.error("ReactionBar: Failed to toggle reaction:", err)
      // Revert optimistic update
      setActive(prev => {
        const next = new Set(prev)
        wasActive ? next.add(kind) : next.delete(kind)
        return next
      })
      setCounts(prev => ({
        ...prev,
        [kind]: prev[kind] + (wasActive ? 1 : -1),
      }))
    } finally {
      setPending(prev => {
        const next = new Set(prev)
        next.delete(kind)
        return next
      })
    }
  }, [activityId, active, pending, onReact])

  return (
    <div className="cf-reaction-bar">
      {REACTIONS.map(r => (
        <button
          key={r.kind}
          className={`cf-reaction-btn ${active.has(r.kind) ? "cf-reaction-btn--active" : ""}`}
          onClick={() => toggleReaction(r.kind)}
          disabled={pending.has(r.kind)}
          title={r.label}
        >
          <span className="cf-reaction-btn__emoji">{r.emoji}</span>
          {counts[r.kind] > 0 && (
            <span className="cf-reaction-btn__count">{counts[r.kind]}</span>
          )}
        </button>
      ))}
    </div>
  )
}

export default ReactionBar
